import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import constClass from '../../Constants/Constants';
import { useHistory } from 'react-router-dom';

const BenefitUse = ({ benefitId, siteId, mallId, shopCode, customerId, liffAccessToken }) => {
  const history = useHistory();
  const [benefitInfo, setBenefitInfo] = useState([]);
  const [values, setValues] = useState({
    address: "",
    postal_code: "",
    name: "",
    email: "",
    phone_number: ""
  });

  //バックエンドサーバから会員に関する情報を取得
  const refreshData = useCallback(async () => {
    try {
      const benefit = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefit/line/${siteId}/${benefitId}/`, { customer_id: customerId, line_id: liffAccessToken, mall_id: mallId })).data;
      setBenefitInfo(benefit);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, benefitId, mallId, customerId, liffAccessToken]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  const handleApplyContentClick = async () => {
    if (!String(values.address)) {
      window.alert('住所を入力してください。');
      return;
    }
    if (!String(values.postal_code)) {
      window.alert('郵便番号を入力してください。');
      return;
    }
    if (!String(values.name)) {
      window.alert('氏名を入力してください。');
      return;
    }
    if (!String(values.phone_number)) {
      window.alert('電話番号を入力してください。');
      return;
    }
    if (!String(values.email)) {
      window.alert('メールアドレスを入力してください。');
      return;
    }
    if (!window.confirm(`この内容で申し込みます。よろしいですか？`)) {
      return;
    }
    var data = {
      'site_id': siteId,
      'benefit_id': benefitInfo.benefit_id,
      'customer_id': customerId,
      'line_id': liffAccessToken,
      'status': constClass.BENEFIT_STATUS.NOTSENT,
      'address': values.address ? values.address : "",
      'postal_code': values.postal_code ? values.postal_code : "",
      'phone_number': values.phone_number ? values.phone_number : "",
      'email': values.email ? values.email : "",
      'name': values.name ? values.name : "",
      'limit_date': benefitInfo.expiry,
      'mall_id': mallId,
      'receiving_type': benefitInfo.receiving_type,
    };
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/line`, data);
      history.push(`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.DELIVERYBENEFITFINISH}`);
    } catch (err) {
      // alert('エラーが発生しました。');
      console.log(err);
    }
  }

  const handleUseBenefitClick = async () => {
    if (!window.confirm(`クーポンを発行します。よろしいですか？`)) {
      return;
    }
    var data = {
      'site_id': siteId,
      'benefit_id': benefitInfo.benefit_id,
      'customer_id': customerId,
      'line_id': liffAccessToken,
      'status': constClass.BENEFIT_STATUS.NOTUSED,
      'limit_date': benefitInfo.expiry,
      'mall_id': mallId,
      'receiving_type': benefitInfo.receiving_type,
    };
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/line`, data);
      history.push(`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.BENEFITFINISH}`);
    } catch (err) {
      // alert('エラーが発生しました。');
      console.log(err);
    }
  }

  const handleReceiveCouponClick = async () => {
    if (!window.confirm(`クーポンを発行します。よろしいですか？`)) {
      return;
    }
    var data = {
      'site_id': siteId,
      'benefit_id': benefitInfo.benefit_id,
      'customer_id': customerId,
      'line_id': liffAccessToken,
      'status': constClass.BENEFIT_STATUS.NOTUSED,
      'limit_date': benefitInfo.expiry,
      'mall_id': mallId,
      'receiving_type': benefitInfo.receiving_type,
    };
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/benefitgrant/line`, data);
      history.push(`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.BENEFITFINISH}`);
    } catch (err) {
      // alert('エラーが発生しました。');
      console.log(err);
    }
  }

  const checkInvalid = () => {
    const check = !values.postal_code || !values.address || !values.name || !values.phone_number || !values.email ? true : false;
    return check;
  }

  return (
    <div id="benefitInfoUse" className="px-0-env">
      <div className="mx-3 mt-1 mb-3">
        <div className="row mx-0 px-3 pt-2 pb-1">
          {benefitInfo.benefit_image_url && <img className="benefit-detail-image" src={`/${siteId}/${constClass.BENEFIT_IMAGE_DIR}${benefitInfo.benefit_image_url}`} alt={benefitInfo.benefit_title} style={{ objectFit: 'cover' }} />}
          {!benefitInfo.benefit_image_url && <img className="benefit-detail-image" src={`/${siteId}/nodetailimage.png`} alt="nodetailimage" style={{ objectFit: 'cover' }} />}
        </div>
        <div className="row mx-0 px-3-env pt-2">
          <div className="col py-1 px-1 mt-2 align-self-center text-center frame11">
            <h4 className="p-0 m-0 benefit_title_infouse">{benefitInfo.benefit_title}</h4>
            {benefitInfo.benefit_summary && <div className="p-0 m-0 mt-2 benefit_summary_infouse">{benefitInfo.benefit_summary}</div>}
          </div>
        </div>
        <div className='vector20'></div>
        <div className="mx-0 px-3-env pt-2 pb-1">
          {benefitInfo.receiving_type === constClass.RECEIVING_TYPE.TICKET_DELIVERY &&
            <React.Fragment>
              <div className="col py-1 px-1 align-self-center text-center">
                この特典はチケットをお送りいたします。                
              </div>
              <div className="col py-1 px-1 align-self-center text-center">
                お届け先の住所・氏名をご記入ください。
              </div>              
              <div className="row mt-3">
                <div className={`col-auto px-0 align-self-center`}><span>住所</span></div>
                <input
                  type="text"
                  name="address"
                  className="form-control mb-2"
                  placeholder="住所"
                  value={values.address}
                  onChange={handleChange}
                />
                <div className={`col-auto px-0 align-self-center`}><span>郵便番号</span></div>
                <input
                  type="text"
                  name="postal_code"
                  className="form-control mb-2"
                  placeholder="郵便番号"
                  value={values.postal_code}
                  onChange={handleChange}
                />
                <div className={`col-auto px-0 align-self-center`}><span>電話番号</span></div>
                <input
                  type="text"
                  name="phone_number"
                  className="form-control mb-2"
                  placeholder="電話番号"
                  value={values.phone_number}
                  onChange={handleChange}
                />
                <div className={`col-auto px-0 align-self-center`}><span>メールアドレス</span></div>
                <input
                  type="text"
                  name="email"
                  className="form-control mb-2"
                  placeholder="メールアドレス"
                  value={values.email}
                  onChange={handleChange}
                />
                <div className={`col-auto px-0 align-self-center`}><span>氏名</span></div>
                <input
                  type="text"
                  name="name"
                  className="form-control mb-4"
                  placeholder="氏名"
                  value={values.name}
                  onChange={handleChange}
                />
              </div>
              <button
                disabled={checkInvalid()}
                onClick={handleApplyContentClick}
                className="button mt-4 text-black bg-lightwhite">
                この内容で申込む
              </button>
            </React.Fragment>
          }
          {benefitInfo.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_BUTTON &&
            <React.Fragment>
              <div className="col py-1 px-1 align-self-center text-center">
                以下のボタンを押すと、
              </div>
              <div className="col py-1 px-1 align-self-center text-center">
                クーポン画面にクーポンが発行されます。
              </div>
              <button
                onClick={handleUseBenefitClick}
                className="button mt-4 text-black bg-lightwhite">
                クーポンを発行する
              </button>
            </React.Fragment>
          }
          {benefitInfo.receiving_type === constClass.RECEIVING_TYPE.DIGITAL_TICKET_QR &&
            <React.Fragment>
              <div className="col py-1 px-1 align-self-center text-center">
                以下のボタンを押すと、
              </div>
              <div className="col py-1 px-1 align-self-center text-center">
                クーポン画面にクーポンが発行されます。
              </div>
              <button
                onClick={handleReceiveCouponClick}
                className="button mt-4 text-black bg-lightwhite">
                クーポンを発行する
              </button>
            </React.Fragment>
          }
        </div>
      </div>
    </div>
  )
}

export default BenefitUse;